import React from 'react';
import { Alert, Center, Group, Image, Loader, Modal, ScrollArea, SegmentedControl, Stack, Tooltip } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate, faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { kitchenBonScaleSchema, type KitchenBonScale } from 'shared-models/browser';
import { useKitchenBonSize } from './useKitchenBonSize';
import { Button } from '../../../../../components/Button';
import navyModal from '../../../../../components/Modal/navy-modal.module.scss';

export function KitchenBonSizeModal({ tenantId, employeeSession, value, onClose }: {
  tenantId: string; employeeSession: string; value: KitchenBonScale; onClose: () => void;
}) {
  const controller = useKitchenBonSize(tenantId, employeeSession, value, onClose);
  return (
    <Modal opened onClose={controller.close} title="גודל בון מטבח" centered size="md" dir="rtl"
      classNames={{ root: navyModal.root }}
      closeOnClickOutside={!controller.saving} closeOnEscape={!controller.saving} closeButtonProps={{ disabled: controller.saving }}>
      <Stack gap="md">
        <SegmentedControl fullWidth value={String(controller.scale)} disabled={controller.saving}
          styles={{ label: { whiteSpace: 'normal', minHeight: 48, display: 'grid', alignItems: 'center' } }}
          aria-label="גודל בון מטבח"
          data={[{ value: '1', label: 'רגיל ×1' }, { value: '1.5', label: 'גדול ×1.5' }, { value: '2.2', label: 'גדול מאוד ×2.2' }]}
          onChange={(value) => {
            const parsed = kitchenBonScaleSchema.safeParse(Number(value));
            if (parsed.success) controller.setScale(parsed.data);
          }} />
        {controller.error && <Alert color="red" role="alert">{controller.error}</Alert>}
        <ScrollArea h="min(50dvh, 480px)" type="auto">
          {controller.loading ? <Center h={160}><Loader aria-label="טוען תצוגה מקדימה" /></Center>
            : controller.image ? <Image src={controller.image} alt="תצוגה מקדימה של בון מטבח" w="100%" maw={400} h="auto" mx="auto" />
              : <Center h={160}><Tooltip label="טען שוב תצוגה מקדימה"><span><Button variant="icon" ariaLabel="טען שוב תצוגה מקדימה" onClick={controller.retryPreview}>
                <FontAwesomeIcon icon={faArrowsRotate as IconProp} />
              </Button></span></Tooltip></Center>}
        </ScrollArea>
        <Group justify="flex-end">
          <Button variant="cancel" onClick={controller.close} disabled={controller.saving}>ביטול</Button>
          <Button variant="save" onClick={controller.save} loading={controller.saving} disabled={controller.loading || !controller.image}>
            <FontAwesomeIcon icon={faFloppyDisk as IconProp} /> שמור</Button>
        </Group>
      </Stack>
    </Modal>
  );
}